import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Button, InputNumber } from 'antd';
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { toInt } from "../../../../swzutils/TypeUtils";
const NumberTableFilter = ({ defaultValue, min, max, placeholder, onApplyFilter, onClearFilter }) => {
    const [value, setValue] = useState(defaultValue ? toInt(defaultValue[0], null) : undefined);
    const inputRef = useRef(null);
    const applyFilterClicked = () => {
        onApplyFilter(value ? [value] : null);
    };
    const clearFilterClicked = () => {
        setValue(undefined);
        onClearFilter();
    };
    return (_jsxs("div", { className: "custom-filter-dropdown", children: [_jsx(InputNumber, { ref: inputRef, placeholder: placeholder, min: min, max: max, value: value, onChange: setValue, onPressEnter: applyFilterClicked }), _jsx(Button, { type: "primary", onClick: applyFilterClicked, children: _jsx(SearchOutlined, {}) }), "\u00A0", _jsx(Button, { type: "default", onClick: clearFilterClicked, children: _jsx(CloseOutlined, {}) })] }));
};
export default NumberTableFilter;
